import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Steps from 'modals/ModalController/Steps';
import SelectStudents from './SelectStudents';
import SelectStaff from './SelectStaff';
import SelectLeads from './SelectLeads';
import './style.scss';

class SelectDocumentRecipients extends PureComponent {
  static propTypes = {
    data: PropTypes.object
  };

  static defaultProps = {
    data: {}
  };

  steps = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      startStep: props.data.startStep || 0,
      selectedKidIds: props.data.kidIds || [],
      selectedStaffIds: props.data.staffIds || [],
      selectedLeadIds: props.data.leadIds || []
    };
  }

  @bind
  updateSelectedKidIds(selectedKidIds) {
    this.setState({ selectedKidIds });
  }

  @bind
  updateSelectedStaffIds(selectedStaffIds) {
    this.setState({ selectedStaffIds });
  }

  @bind
  updateSelectedLeadIds(selectedLeadIds) {
    this.setState({ selectedLeadIds });
  }

  @bind
  openSelectKids() {
    this.steps.current.goToStep('select-kids');
  }

  @bind
  openSelectStaff() {
    this.steps.current.goToStep('select-staff');
  }

  @bind
  handleSubmit() {
    this.props.onClose({
      kidIds: this.state.selectedKidIds,
      staffIds: this.state.selectedStaffIds,
      leadIds: this.state.selectedLeadIds
    });
  }

  render() {
    const { selectedKidIds, selectedStaffIds, selectedLeadIds, startStep } = this.state;

    return (
      <div className="select-document-recipients">
        <Steps ref={this.steps} startStep={startStep}>
          <Steps.Item name="select-kids">
            <SelectStudents
              selectedKidIds={selectedKidIds}
              onSelect={this.updateSelectedKidIds}
              onSubmit={this.handleSubmit}
            />
          </Steps.Item>

          <Steps.Item hidden name="select-staff">
            <SelectStaff
              selectedStaffIds={selectedStaffIds}
              onSelect={this.updateSelectedStaffIds}
              onSubmit={this.handleSubmit}
            />
          </Steps.Item>

          <Steps.Item hidden name="select-leads">
            <SelectLeads
              selectedLeadIds={selectedLeadIds}
              onSelect={this.updateSelectedLeadIds}
              onSubmit={this.handleSubmit}
            />
          </Steps.Item>
        </Steps>
      </div>
    );
  }
}

export default SelectDocumentRecipients;
